/*!
 * ST 2026-07-11 — Deep-Link Sold-Out Variant Reconcile (Fix H3)
 * -----------------------------------------------------------------------------
 * PROBLEM: Landet ein Besucher via ?variant=<ID> direkt auf einer AUSVERKAUFTEN
 * Variante (z. B. Vorführgerät on_hand=0, aus Ads/Newsletter/Google-Cache), rendert
 * der Server Preis + "In den Warenkorb" für DIESE ausverkaufte Variante, während der
 * Picker (bei hide_sold_out_variants) bereits das Radio/Option der ersten VERFÜGBAREN
 * Variante force-checkt. Concepts VariantPicker reagiert aber nur auf echte 'change'-
 * Events und macht KEINE Reconciliation beim Laden -> Widerspruch: markierte Option
 * verfügbar, Button "Ausverkauft", Preis passt zu keiner der beiden. Erst ein Klick
 * des Nutzers glättet es -> viele springen ab.
 *
 * FIX (additiv, KEIN Core-theme.js-Edit): Ist die deep-verlinkte Variante ausverkauft,
 * feuern wir EINMAL ein natives 'change' auf dem bereits gecheckten Steuerelement. Das
 * triggert die bestehende, vetteste Concept-Kette:
 *   VariantPicker.handleVariantChange -> publishSelectionChange
 *   -> ProductInfo.handleOptionValueChange -> renderProductInfo (Section-Fetch)
 *   -> Preis/Financing/BuyButton/StickyPrice/Badges/Inventory/URL werden auf die
 *      verfügbare Variante nachgezogen (theme.js:5686–5704).
 * Es wird KEINE Varianten-Matching-Logik dupliziert; wir stoßen nur an, was ein
 * Nutzerklick ohnehin auslösen würde.
 *
 * SCOPE / SICHERHEIT:
 *  - Nur Haupt-PDP: product-info OHNE data-original-section-id (Quick-View übersprungen).
 *  - Nur wenn ?variant= gesetzt UND laut data-variants unavailable. Normale Loads
 *    (kein Deep-Link / verfügbare Variante) laufen früh in return -> 0 Effekt, 0 Fetch.
 *  - Komplett try/catch -> darf die PDP unter keinen Umständen brechen.
 *  - Deckt Button-, Swatch-, Variant- (Radios) UND Dropdown-Picker (Select) ab.
 *
 * ROLLBACK: dieses Asset löschen + die eine <script>-Zeile in
 *           sections/main-product.liquid ("ST 2026-07-11: Deep-Link…") entfernen.
 */
(function () {
  'use strict';

  function reconcile() {
    var urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (!urlVariantId) return; // kein Deep-Link -> nichts zu tun

    var pickers = document.querySelectorAll(
      'product-info:not([data-original-section-id]) variant-picker'
    );

    pickers.forEach(function (picker) {
      try {
        var dataEl = picker.querySelector('[data-variants]');
        if (!dataEl) return;

        var variants = JSON.parse(dataEl.textContent || '[]');
        var urlVariant = variants.find(function (v) {
          return String(v.id) === String(urlVariantId);
        });

        // Nur handeln, wenn die verlinkte Variante existiert UND ausverkauft ist.
        // (Verfügbar -> alles korrekt; nicht gefunden -> nicht dieser Picker.)
        if (!urlVariant || urlVariant.available !== false) return;

        // Das durch hide_sold_out_variants force-gecheckte aktive Steuerelement:
        // Radio-Picker (button/swatch/variant) ODER Dropdown (select).
        var control = picker.querySelector('fieldset input:checked') ||
                      picker.querySelector('select');
        if (!control) return;

        // Einmaliges natives 'change' -> Concept reconciled Preis/Button/URL auf die
        // verfügbare (force-gecheckte) Variante. bubbles:true, damit der Listener am
        // <variant-picker> es erhält.
        control.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        /* defensiv: eine kaputte Variante darf die PDP nie blockieren */
      }
    });
  }

  // Nach theme.js (defer, im <head>) -> Custom Elements sind upgraded + ProductInfo hat
  // seinen optionValueSelectionChange-Subscriber registriert. rAF = Sicherheitspuffer.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(reconcile);
    }, { once: true });
  } else {
    requestAnimationFrame(reconcile);
  }
})();
